import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { Observable } from 'rxjs';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class SucursalService {
  controller: string = "sucursal/";
  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }

  create(data: any, user: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'create', { sucursal: data, usuario: user }, this.sesion.headers);
  }
  update(data: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'update/' + data.id, { sucursal: data }, this.sesion.headers);
  }
  delete(data: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + 'delete/' + data, this.sesion.headers);
  }
  view(id: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "view/" + id, this.sesion.headers);
  }
  misSucursales(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'mis-sucursales', this.sesion.headers);
  }
  select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'select', this.sesion.headers);
  }
}
